import {lazyRegister} from '@/Core/lazyRegister';
import {BaseApiFactory} from "@/Factories/BaseApiFactory";
import {CategorySpot, CreateCategorySpotCommand, DeleteCategorySpotCommand} from "@/models";

export class SpotService {
    static readonly $inject = ['BaseApiFactory'];

    constructor(private baseApiFactory: BaseApiFactory) {
    }

    GetAllSpots(query: {
        categoryId: number,
        langCode: string
    }, cancelToken: AbortSignal = null) {
        return this.baseApiFactory
            .getData<CategorySpot[]>(`/api/CategorySpot/category/${query.categoryId}/${query.langCode}`, null, cancelToken);
    }

    GetById(id: number, cancelToken: AbortSignal = null) {
        return this.baseApiFactory.getData<CategorySpot>(`/api/CategorySpot/${id}`, null, cancelToken);
    }

    InsertSpot(value: CreateCategorySpotCommand, cancelToken: AbortSignal = null) {
        return this.baseApiFactory.post<number>('/api/CategorySpot', value, cancelToken);
    }

    UpdateSpot(value: {
        Id: number,
        CategoryId: number,
        Content: string
    }, cancelToken: AbortSignal = null) {
        return this.baseApiFactory.put('/api/CategorySpot', value, cancelToken);
    }

    UpateOrder(values: CategorySpot[], cancelToken: AbortSignal = null) {
        return this.baseApiFactory.post<boolean>('/api/CategorySpot/order', values, cancelToken);
    }

    DeleteCategorySpot(value: DeleteCategorySpotCommand, cancelToken?: AbortSignal) {
        return this.baseApiFactory.delete<boolean>('/api/CategorySpot/DeleteCategorySpot', value, cancelToken);
    }
}

lazyRegister.service('SpotService', SpotService);

